import { Box } from '@mui/material';

import * as React from 'react';
import pxToRem from 'assets/theme/function/px-to-rem';
import BackNavigate from 'component/back-navigate/back-navigate';
import NotificationDetailsParams from 'pages/notification/notification-details/notification-details-params';
import { useParams } from 'react-router-dom';
import Filter from 'component/filter';

const NotificationDetails: React.FC = () => {
    const { notificationId, status } = useParams();

    return (
        <>
            <Box mb={pxToRem(5)} display="grid" alignItems="center">
                <BackNavigate navigateUrl={'/notification'} />
            </Box>
            <Filter name={'Notification Details'} display={true} />
            <Box
                sx={{
                    pointerEvents:
                        notificationId &&
                        (status === 'active' ||
                            status === 'archive' ||
                            status === 'done')
                            ? 'none'
                            : 'auto',
                    opacity:
                        notificationId &&
                        (status === 'active' ||
                            status === 'archive' ||
                            status === 'done')
                            ? 0.5
                            : 1,
                }}
            >
                <NotificationDetailsParams
                    notificationId={notificationId}
                    status={status}
                />
            </Box>
        </>
    );
};
export default NotificationDetails;
